export const HideComponent = {
    namespaced: true,

    state: {
        open: [],
    },

    mutations: {
        add: (state, data) => {
            state.open.push(data);
        },
        remove: (state) => {
            state.open.pop();
        }
    },

    getters: {
        last(state) {
            return state.open[state.open.length - 1];
        }
    }
}
